// extracted by mini-css-extract-plugin
module.exports = {"app":"_3xmY6","postPageApp":"_1A6gh","scrollable":"PiVgL","backgroundOverlay":"_2193b"};